import styled from 'styled-components';

import {colors, font} from 'theme';

export const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`;

export const Logo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    background-color: #e6f7e5;
    border-radius: 50%;
`;

export const TextWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

export const TextHeadline = styled.div`
    width: 100%;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    font-family: ${font.family.primary};
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0px;
    color: ${colors.darkGrey};
`;

export const TextBody = styled.div`
    width: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0px;
    color: ${colors.textSecondary};
`;
